import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsEmailNotificationsLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './SettingsEmailNotificationsSuspense')
);

export const SettingsEmailNotificationsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsEmailNotificationsLazy />
    </DelayedSuspense>
);
